import Backbone from 'backbone';
import { View } from 'backbone.marionette';
import template from './index.jst';
import './index.styl';
import { User as UserModel } from '../../models';
import {
	redirectTo,
	ErrorsModal,
	Preloader
} from '../../utils';
import Radio from "backbone.radio";

const userChannel = Radio.channel('userModals');

class LoginView extends View {
	get template() {
		return template;
	}

	get className() {
		return "login-page";
	}

	async initialize() {
		const
			nrl_account_code = this.getOption('nrl_account_code'),
			redirect_uri = this.getOption('redirect_uri');

		this.application = this.getOption('application');

		this.setListeners();

		this.model = new Backbone.Model({
			status: 'loading'
		});

		Preloader.show();

		await UserModel.loginWithNRLAuthCode({
			code: nrl_account_code,
			redirect_url: redirect_uri
		});

		this.model.set({
			status: 'done'
		});

		Preloader.hide();

		this.render();
	}

	setListeners() {
		this.listenTo(
			UserModel,
			'user:logged:in',
			this.loginSuccess
		);

		this.listenTo(
			UserModel,
			'user:login:fail',
			this.loginFail
		);
	}

	loginSuccess() {
		// Overwrite in extended view if required
		redirectTo();
		return Backbone.history.loadUrl();
	}

	async loginFail(errors) {
		Preloader.show();

		const error_code = errors[0].code;
		if (error_code === 404) {
			// this.redirectToOnboarding();
			this.showOnboardingModal();

			return;
		}

		Preloader.hide();

		ErrorsModal.show(errors);

		return redirectTo();
	}

	showOnboardingModal() {
		userChannel.trigger('show:onboarding:modal');
		return redirectTo();
	}

	redirectToOnboarding() {
		return redirectTo('onboarding');
	}
}

export default LoginView;